import {
  SET_SELECTED_OPTION,
  REMOVE_SELECTED_OPTION,
  CLEAR_SELECTED_OPTIONS,
} from '../../actions/options';

export const initialState = {
  selectedOptions: {},
  unSelectedKeys: [],
};

/* eslint-disable camelcase */
export default (
  state = initialState,
  { type, data: { option: { key, value, post_data } = {}, optionName = null } = {} } = {},
) => {
  /* eslint-enable */
  switch (type) {
    case SET_SELECTED_OPTION:
      return {
        ...state,
        selectedOptions: { ...state.selectedOptions, [key]: { value, post_data } },
      };

    case REMOVE_SELECTED_OPTION:
      delete state.selectedOptions[optionName];
      return {
        ...state,
        selectedOptions: {
          ...state.selectedOptions,
        },
        unSelectedKeys: [...state.unSelectedKeys, optionName],
      };

    case CLEAR_SELECTED_OPTIONS:
      return { ...initialState };

    default:
      return state;
  }
};
